import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import Select from 'react-select';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import { LookupMaterias } from '../MateriaCarrera/LookupMaterias';
import { SELECT_LABELS, selectPlaceholder, withSelectPlaceholder } from '../../services/selectOptions';

const CONDICION_OPTIONS = withSelectPlaceholder(
  [
    { value: 'A', label: 'Aprobada' },
    { value: 'R', label: 'Regular' },
  ],
  SELECT_LABELS.condicionCorrelativa
);

const SELECT_CLASS_NAMES = {
  control: () => 'md-form-page__select__control',
};

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export class AddCorrelatividadRendir extends Component {
  static displayName = AddCorrelatividadRendir.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errorMessage: '',
      redirect: false,
      showLookupMateria: false,
      showLookupCorrelativa: false,
      carreraCursada: -1,
      materiaInicial: { codigo: '', descripcion: '' },
      materiaCorrelativa: { codigo: '', descripcion: '' },
      valueCondicion: selectPlaceholder(SELECT_LABELS.condicionCorrelativa),
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    constantClass.canAccess('WWCorrelatividadesRendir');
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleShowMateriaLookup = () => {
    if (!this.state.loading) {
      this.setState({ showLookupMateria: true });
    }
  };

  handleShowCorrelativaLookup = () => {
    if (!this.state.loading && this.state.carreraCursada !== -1) {
      this.setState({ showLookupCorrelativa: true });
    }
  };

  handleHideMateriaLookup = () => {
    this.setState({ showLookupMateria: false });
  };

  handleHideCorrelativaLookup = () => {
    this.setState({ showLookupCorrelativa: false });
  };

  handleSelectMateriaItem = (e) => {
    const properties = e.split('%');
    this.clearFeedback();
    this.setState({
      showLookupMateria: false,
      carreraCursada: Number(properties[3]),
      materiaInicial: {
        codigo: properties[0],
        descripcion: properties[1] + ' - ' + properties[2],
      },
      materiaCorrelativa: { codigo: '', descripcion: '' },
    });
  };

  handleSelectCorrelativaItem = (e) => {
    const properties = e.split('%');
    this.clearFeedback();
    this.setState({
      showLookupCorrelativa: false,
      materiaCorrelativa: {
        codigo: properties[0],
        descripcion: properties[1] + ' - ' + properties[2],
      },
    });
  };

  handleCondicionChange = (option) => {
    this.clearFeedback();
    this.setState({ valueCondicion: option });
  };

  isFormValid() {
    return (
      this.state.materiaInicial.codigo.length > 0
      && this.state.materiaCorrelativa.codigo.length > 0
      && this.state.valueCondicion
      && this.state.valueCondicion.value !== ''
    );
  }

  handleSubmit(e) {
    e.preventDefault();
    if (isSubmitInProgress(this.state.loading)) return;
    if (!this.isFormValid()) {
      this.setState({ errorMessage: 'Todos los campos son obligatorios.' });
      return;
    }
    this.saveRecord();
  }

  async saveRecord() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '' });

    const { data } = await constantClass.apiFetch('api/crendir', {
      method: 'POST',
      body: JSON.stringify({
        MateriaCarreraCod: this.state.materiaCorrelativa.codigo,
        MateriaCarreraCod2: this.state.materiaInicial.codigo,
        CorrelatividadRendirCondicion: this.state.valueCondicion.value,
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || data.returnModel === false) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo guardar la correlatividad. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-crendir" />;
    }

    const {
      loading,
      errorMessage,
      materiaInicial,
      materiaCorrelativa,
      valueCondicion,
      showLookupMateria,
      showLookupCorrelativa,
      carreraCursada,
    } = this.state;
    const isBusy = loading;
    const canPickCorrelativa = carreraCursada !== -1;

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-crendir">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">Nueva Correlatividad para Rendir</h1>
        <p className="md-form-page__subtitle">
          Seleccione la materia, su correlativa y la condición requerida para rendir.
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Guardando correlatividad, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Materia</span>
              <button
                type="button"
                className="md-form-page__pick-btn"
                onClick={this.handleShowMateriaLookup}
                disabled={isBusy}
              >
                Seleccione la Materia
              </button>
              {showLookupMateria ? (
                <LookupMaterias
                  selectItem={this.handleSelectMateriaItem}
                  hideLookup={this.handleHideMateriaLookup}
                />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={materiaInicial.descripcion}
                placeholder="Materia seleccionada"
                readOnly
                disabled
                aria-label="Materia"
              />
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Correlativa</span>
              {canPickCorrelativa ? (
                <button
                  type="button"
                  className="md-form-page__pick-btn"
                  onClick={this.handleShowCorrelativaLookup}
                  disabled={isBusy}
                >
                  Seleccione la Correlativa
                </button>
              ) : (
                <p className="md-form-page__empty-hint">Seleccione primero la Materia</p>
              )}
              {showLookupCorrelativa ? (
                <LookupMaterias
                  selectItem={this.handleSelectCorrelativaItem}
                  hideLookup={this.handleHideCorrelativaLookup}
                />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={materiaCorrelativa.descripcion}
                placeholder="Correlativa seleccionada"
                readOnly
                disabled
                aria-label="Correlativa"
              />
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Condición</span>
              <div className="md-form-page__select-wrap">
                <Select
                  inputId="crendir-condicion"
                  classNamePrefix="md-form-page__select"
                  classNames={SELECT_CLASS_NAMES}
                  value={valueCondicion}
                  options={CONDICION_OPTIONS}
                  onChange={this.handleCondicionChange}
                  isDisabled={isBusy}
                />
              </div>
            </div>

            <div className="md-form-page__actions">
              <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={isBusy}>
                Confirmar
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
